import getCheckedBoxValuesByName from './helpers';
import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import select2 from 'select2';

export default {
  init() {
    const previewFiles = () => {
      const preview = document.getElementById('preview');
      preview.innerHTML = '';
      const files = document.querySelector('input[type=file]').files;

      const readAndPreview = (file) => {
        if (/\.(jpe?g|png)$/i.test(file.name)) {
          const reader = new FileReader();

          reader.addEventListener('load', () => {
            if (preview) {
              preview.src = reader.result;
              preview.classList.remove('hidden');
            }
          }, false);
          reader.readAsDataURL(file);
        }
      }

      if (files) {
        [].forEach.call(files, readAndPreview);
      }
    }

    const input = document.getElementById('image');
    if (input) {
      input.addEventListener('change', previewFiles);
    }

    let targetSelector = "";
    if (document.getElementById('influencer-profile')) {
      targetSelector = 'influencer-profile';
    } else if (document.getElementById('influencer-settings')) {
      targetSelector = 'influencer-settings';
    } else if (document.getElementById('company-profile')) {
      targetSelector = 'company-profile';
    } else if (document.getElementById('company-settings')) {
      targetSelector = 'company-settings';
    } else {
      return;
    }

    const formElement = document.getElementById(targetSelector);

    const toggleSaveMode = (e) => {
      e.preventDefault();
      const parElm = e.target.parentNode;
      const childrenToToggle = parElm.querySelectorAll('.js-toggle-hidden');

      const mode = parElm.getAttribute('data');
      if (mode === 'gender' && window.innerWidth > 1280) {
        parElm.classList.remove('xl:w-1/2');
      }
      childrenToToggle.forEach(el => {
        el.classList.toggle('hidden');
      });
    }

    const saveData = (e) => {
      const message = document.getElementById('form-save');
      message.classList.remove('hidden');

      const parElm = e.target.parentNode;
      const mode = parElm.getAttribute('data');

      if (mode) {
        if ('interests' === mode) {
          const targetElm = document.getElementById('interests');
          targetElm.innerHTML = "";
          const interestList = JSON.parse(window.interests_full_labels);

          const newInterests = $('[name="interests[]"]').select2('data');
          if (newInterests) {
            newInterests.forEach(i => {
              let child = document.createElement('div');
              child.className = window.interest_css;
              child.innerHTML = interestList[i.id];
              targetElm.appendChild(child);
            });
          }
        } else if ('gender' === mode) {
          const newGender = getCheckedBoxValuesByName('gender');
          if (newGender) {
            const targetElm = document.getElementById('gender');
            targetElm.innerHTML = newGender[0];
            if (window.innerWidth > 1280) {
              parElm.classList.add('xl:w-1/2');
            }
          }
        } else if ('paypal_identifier' === mode) {
          const inputElm = document.querySelector('input[name="paypal_identifier"]');
          const targetElm = document.getElementById('paypal_identifier');
          if (inputElm && targetElm) {
            targetElm.innerHTML = inputElm.value;
          }
        } else if ('region' === mode) {
          const inputElm = document.querySelector('[name="' + mode + '"]:checked');
          const targetElm = document.getElementById(mode);
          if (inputElm && targetElm) {
            targetElm.innerHTML = inputElm.dataset.label;
          }
        } else if ('social_media' !== mode) {
          const inputElm = document.querySelector('[name="' + mode + '"]');
          const targetElm = document.getElementById(mode);
          if (inputElm && targetElm) {
            targetElm.innerHTML = inputElm.value;
          }
        }
      }

      // Prevent browser from autofill hidden password fields
      var passwordElm = document.querySelector('input[name="password"]');
      window.passwordElm = passwordElm;
      var passwordConfirmElm = document.querySelector('input[name="confirm_password"]');
      if(passwordElm !== null && passwordElm.clientHeight === 0 && passwordConfirmElm.clientHeight === 0){
        passwordConfirmElm.value = '';
        passwordElm.value = '';
      }

      const childrenToToggle = parElm.querySelectorAll('.js-toggle-hidden');

      let FD = new FormData(formElement);

      if ('influencer-profile' === targetSelector) {
        FD.append('action', 'influencer_profile');
      } else if ('influencer-settings' === targetSelector) {
        FD.append('action', 'influencer_settings');
      } else if ('company-profile' === targetSelector) {
        FD.append('action', 'company_profile');
      } else if ('company-settings' === targetSelector) {
        FD.append('action', 'company_settings');
      }

      if (document.querySelector('input[type=file]')) {
        const files = document.querySelector('input[type=file]').files;
        if (files && files[0]) {
          FD.append("file", files[0]);
        }
      }
      let request = new XMLHttpRequest();
      request.open('POST', window.ajax_object.ajaxurl, true);
      request.onload = function () {
        if (this.status >= 200 && this.status < 400) {
          if (request.response) {
            const data = JSON.parse(request.response);
            if (data.error) {
              alert(data.error_message);
            } else {
              setTimeout(function () {
                message.classList.add('hidden');
              }, 750);
              if (mode === 'social_media' && data && data.social_media) {
                window.social_media = data.social_media;
                const parentTable = document.querySelector('.js-social-media-tbody');
                parentTable.innerHTML = '';

                data.social_media.forEach(sm => {
                  let img_source = "";
                  if (sm.platform.toLowerCase() === 'instagram') {
                    img_source = window.instagram_img;
                  } else if (sm.platform.toLowerCase() === 'youtube') {
                    img_source = window.youtube_img;
                  } else if (sm.platform.toLowerCase() === 'facebook') {
                    img_source = window.facebook_img;
                  } else {
                    img_source = window.blog_img;
                  }

                  parentTable.innerHTML += '<tr><td class="pr-6">' +
                    '<img class="w-5 h-auto" src="' + img_source + '"></img>' +
                    '</td><td class="pr-6">' +
                    '<a class="text-black" href="' + sm.url + '">' + sm.platform + '</a>'
                    + '</td>' + '<td class="pr-6">' + sm.followers + '</td>' + '</tr>';
                });
              }

              childrenToToggle.forEach(el => {
                el.classList.toggle('hidden');
              });
            }
          }
        }
      };
      request.onerror = function (err) {
        console.log(err);
      };
      request.send(FD);
    }

    if (formElement) {
      const change_buttons = document.querySelectorAll('.js-toggle-input');
      change_buttons.forEach(btn => {
        btn.addEventListener('click', toggleSaveMode);
      });

      const save_buttons = document.querySelectorAll('.js-save-form');
      save_buttons.forEach(btn => {
        btn.addEventListener('click', saveData);
      });

      formElement.addEventListener("submit", function (e) {
        e.preventDefault();
      });
    }

    $('input[type=radio][name=payment_method]').on('change', (e) => {
      const choosenPayment = $('#payment-options #' + e.target.id + '-wrapper');
      choosenPayment.show();
      choosenPayment.siblings().hide();
    });

    $('.js-save-invoice').on('click', (e) => {
      $('.invoice-error').removeClass('inline-block').addClass('hidden');
      const input_fields = $(e.target).siblings('input');

      const errors = [];
      input_fields.each(input => {
        if ( input_fields[input].value === '' ) {
          errors.push(input_fields[input].name);
        }
      });

      // Check if payment option has been selected
      if ( ! $( 'input[name=payment_option]:checked' ).val() ) {
        errors.push('payment_option');
      }

      if( 'iban' === $( 'input[name=payment_option]:checked' ).val() && $('input[name="bank_iban_name"]').val().trim().length < 8){
        errors.push('bank_iban_name');
      }
      
      if (errors.length > 0) {  
        errors.forEach(element => {
          $('.' + element + '-error').removeClass('hidden').addClass('inline-block');
        });
      } else {
        saveData(e);
      }
    });

    $('input[type=radio][name=payment_option]').on('change', (e) => {
      const paymentOption = e.target.value;
      $('.payment-option-toggle').addClass('hidden');
      if(paymentOption === 'iban'){
        $('.payment-option-iban').removeClass('hidden');
      } else if (paymentOption === 'bankgiro' || paymentOption === 'postgiro') {
        $('.payment-option-other').removeClass('hidden');
      } else if (paymentOption === 'account') {
        $('.payment-option-accountnumber').removeClass('hidden');
      }
    
    });
  },
  finalize() {
    if ($('.select2').length) {
      $('.select2').select2({
        multiple: true,
        maximumSelectionLength: 5
      });
    }
  },
};
